import { OrderedMap } from 'immutable'
import _map from 'lodash/mapValues'

import { SIGN_OUT_SUCCESS } from 'modules/auth'
import { LOAD_QUEUES_SUCCESS, EMPTY_QUEUES_LIST, CURRENT_QUEUE_NEW_STATUS } from '../action-types'
import { SET_CURRENT_SITE } from '../../sites/action-types'

export default function(state = new OrderedMap(), { type, payload, ...rest }) {
  switch (type) {
    case LOAD_QUEUES_SUCCESS:
      return payload.reduceRight((map, item) => {
        const { key, ...statuses } = item
        let prevKey = null
        const iteratee = (value, statusKey) => {
          const status = { ...value, prevKey }
          prevKey = statusKey
          return status
        }
        return map.set(key, new OrderedMap(_map(statuses, iteratee)))
      }, new OrderedMap())

    case CURRENT_QUEUE_NEW_STATUS:
      if (!state.size) {
        // First queue for the site.
        return state.set(rest.queueId, new OrderedMap({ [rest.key]: { ...payload, key: rest.key } }))
      }
      else if (state.has(rest.queueId)) {
        // Add new status to existing queue.
        return state.setIn([rest.queueId, rest.key], { ...payload, key: rest.key })
      }
      else {
        // Add new queue at the start of the map.
        return (new OrderedMap({ [rest.queueId]: new OrderedMap({ [rest.key]: { ...payload, key: rest.key } })}))
          .concat(state)
      }

    case SIGN_OUT_SUCCESS:
    case SET_CURRENT_SITE:
    case EMPTY_QUEUES_LIST:
      return new OrderedMap()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/queues/reducers/site-queues.js